"use client";

import { c as _c } from "react/compiler-runtime";
import { EASE_OUT_QUART } from "@/lib/animation-constants";
import { motion, useInView } from "motion/react";
import { useCallback, useEffect, useRef, useState } from "react";
import { AiLights } from "./AiLights";
import { GridBorderedSection, GridDivider } from "./GridLayout";
const AI_PROMPTS = ["Fund all gas wallets", "Copytrade Polymarket", "Pay Contractors"];
const INNER_GLOW_MASK = "radial-gradient(ellipse 60% 70% at 50% 50%, transparent 40%, black 100%)";
const GRID_H_LINES = Array.from({
  length: 6
}, (_, i) => i);
const GRID_V_LINES = Array.from({
  length: 10
}, (_, i) => i);
function useTypingEffect(strings, t0) {
  const $ = _c(17);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    typeSpeed: t2,
    deleteSpeed: t3,
    pauseAfterType: t4,
    pauseAfterDelete: t5
  } = t1;
  const typeSpeed = t2 === undefined ? 60 : t2;
  const deleteSpeed = t3 === undefined ? 35 : t3;
  const pauseAfterType = t4 === undefined ? 2000 : t4;
  const pauseAfterDelete = t5 === undefined ? 500 : t5;
  const [display, setDisplay] = useState("");
  const [typedCount, setTypedCount] = useState(0);
  const prefersReducedMotion = useRef(false);
  const idx = useRef(0);
  const charIdx = useRef(0);
  const phase = useRef("typing");
  let t6;
  let t7;
  if ($[2] !== strings) {
    t6 = () => {
      prefersReducedMotion.current = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (!prefersReducedMotion.current) {
        return;
      }
      const id = window.setTimeout(() => setDisplay(strings[0]), 0);
      return () => window.clearTimeout(id);
    };
    t7 = [strings];
    $[2] = strings;
    $[3] = t6;
    $[4] = t7;
  } else {
    t6 = $[3];
    t7 = $[4];
  }
  useEffect(t6, t7);
  let t8;
  if ($[5] !== deleteSpeed || $[6] !== pauseAfterDelete || $[7] !== pauseAfterType || $[8] !== strings || $[9] !== typeSpeed) {
    t8 = () => {
      const current = strings[idx.current];
      if (phase.current === "typing") {
        charIdx.current = charIdx.current + 1;
        setDisplay(current.slice(0, charIdx.current));
        if (charIdx.current >= current.length) {
          phase.current = "pausing";
          setTypedCount(_temp);
          return pauseAfterType;
        }
        return typeSpeed;
      }
      if (phase.current === "pausing") {
        phase.current = "deleting";
        return deleteSpeed;
      }
      if (phase.current === "deleting") {
        charIdx.current = charIdx.current - 1;
        setDisplay(current.slice(0, charIdx.current));
        if (charIdx.current <= 0) {
          phase.current = "waiting";
          return pauseAfterDelete;
        }
        return deleteSpeed;
      }
      idx.current = (idx.current + 1) % strings.length;
      charIdx.current = 0;
      phase.current = "typing";
      return typeSpeed;
    };
    $[5] = deleteSpeed;
    $[6] = pauseAfterDelete;
    $[7] = pauseAfterType;
    $[8] = strings;
    $[9] = typeSpeed;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const tick = t8;
  let t10;
  let t9;
  if ($[11] !== tick) {
    t9 = () => {
      if (prefersReducedMotion.current) {
        return;
      }
      let timer;
      const schedule = () => {
        const delay = tick();
        timer = setTimeout(schedule, delay);
      };
      schedule();
      return () => clearTimeout(timer);
    };
    t10 = [tick];
    $[11] = tick;
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  useEffect(t9, t10);
  let t11;
  if ($[14] !== display || $[15] !== typedCount) {
    t11 = {
      display,
      typedCount
    };
    $[14] = display;
    $[15] = typedCount;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}
function _temp(c) {
  return c + 1;
}
function NodeCard(t0) {
  const $ = _c(24);
  const {
    title,
    subtitle,
    subtitleColor,
    iconBg,
    icon,
    large,
    button
  } = t0;
  const t1 = `border-ds-neutral-200 shadow-ds-elev-soft-mid relative overflow-clip rounded-xl border ${large ? "w-[300px]" : "w-[250px]"}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute inset-0 rounded-xl bg-white" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pointer-events-none absolute inset-0 rounded-xl" aria-hidden="true">{t2}<div className="absolute inset-0 rounded-xl mix-blend-soft-light" style={{
        background: "linear-gradient(168deg, rgba(23,22,25,0.4) 0%, rgba(229,229,229,0.4) 105%)"
      }} /></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `relative flex items-center gap-1.5 p-2 ${button ? "border-ds-alpha-black-10 shadow-ds-card-halo border-b" : ""}`;
  const t5 = `flex size-[42px] shrink-0 items-center justify-center rounded-lg ${iconBg}`;
  let t6;
  if ($[2] !== icon || $[3] !== t5) {
    t6 = <div className={t5}>{icon}</div>;
    $[2] = icon;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = `text-ds-text-tertiary truncate font-medium leading-5 ${large ? "text-base" : "text-sm"}`;
  let t8;
  if ($[5] !== t7 || $[6] !== title) {
    t8 = <p className={t7}>{title}</p>;
    $[5] = t7;
    $[6] = title;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = `${large ? "text-sm leading-5" : "text-2xs leading-18"} ${subtitleColor}`;
  let t10;
  if ($[8] !== subtitle || $[9] !== t9) {
    t10 = <p className={t9}>{subtitle}</p>;
    $[8] = subtitle;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t8) {
    t11 = <div className="flex flex-1 flex-col overflow-hidden py-0.5">{t8}{t10}</div>;
    $[11] = t10;
    $[12] = t8;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t4 || $[16] !== t6) {
    t12 = <div className={t4}>{t6}{t11}</div>;
    $[14] = t11;
    $[15] = t4;
    $[16] = t6;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== button) {
    t13 = button && <div className="relative flex items-center p-2.5"><div className="rounded-ds-sm from-ds-neutral-700 to-ds-neutral-900 shadow-ds-black relative flex h-9 flex-1 items-center justify-center gap-2 overflow-clip bg-gradient-to-b px-4 py-2"><svg className="size-5" viewBox="0 0 20 20" fill="none"><path d="M7 3L17 10L7 17V3Z" stroke="white" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg><span className="text-2xs leading-label font-medium text-white">{button.label}</span><span className="rounded-inherit shadow-ds-inner-dark pointer-events-none absolute inset-0" /></div></div>;
    $[18] = button;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t1 || $[21] !== t12 || $[22] !== t13) {
    t14 = <div className="rounded-ds-18 border-ds-neutral-200 shadow-ds-card-halo border bg-white/60 p-1.5 backdrop-blur-[12.6px]"><div className={t1}>{t3}{t12}{t13}</div></div>;
    $[20] = t1;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
}
function ChartIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <img alt="Token price chart" src="/images/homepage/token-price-icon.svg" className="size-7" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function ForkIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="size-7" viewBox="0 0 24.79 26.25" fill="none"><path d="M4.375 0C1.959 0 0 1.959 0 4.375c0 2.038 1.394 3.751 3.281 4.237v9.026c-1.887.486-3.281 2.198-3.281 4.237C0 24.291 1.959 26.25 4.375 26.25s4.375-1.959 4.375-4.375c0-2.038-1.394-3.751-3.281-4.237V14.22h16.041V8.612c1.887-.486 3.281-2.199 3.281-4.237C24.792 1.959 22.833 0 20.417 0S16.042 1.959 16.042 4.375c0 2.038 1.394 3.751 3.281 4.237v3.42H5.469V8.612C7.356 8.127 8.75 6.414 8.75 4.375 8.75 1.959 6.791 0 4.375 0z" fill="#7F56D9" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function GridIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <img alt="Google Sheets" src="/images/homepage/google-sheets-icon.png" className="size-7 object-contain" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function BentoCaption(t0) {
  const $ = _c(7);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className="text-ds-brand-600 leading-label text-2xl font-medium">{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <p className="text-ds-text-subtle leading-label text-lg opacity-80">{description}</p>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col items-center gap-2 px-6 pb-6 pt-11 text-center">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
const CODE_LINES: {
  widths: number[];
  color: "gray" | "light" | "none";
}[] = [{
  widths: [2, 17],
  color: "gray"
}, {
  widths: [42, 49],
  color: "none"
}, {
  widths: [2, 30, 17],
  color: "light"
}, {
  widths: [2, 19, 18, 17, 32],
  color: "light"
}, {
  widths: [2, 42, 49],
  color: "light"
}, {
  widths: [42, 49],
  color: "none"
}, {
  widths: [2, 18, 19, 19],
  color: "light"
}, {
  widths: [2, 19, 32, 18, 17],
  color: "light"
}, {
  widths: [2, 19, 18, 100, 32],
  color: "light"
}, {
  widths: [2, 30, 31],
  color: "light"
}];
const COLOR_MAP: Record<string, string> = {
  gray: "bg-ds-neutral-200",
  light: "bg-ds-neutral-100",
  none: ""
};
function CodeLines() {
  const $ = _c(6);
  const [activeLine, setActiveLine] = useState(-1);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const total = CODE_LINES.length;
      const interval = setInterval(() => {
        setActiveLine(prev => {
          const next = prev + 1;
          return next > total + 2 ? -1 : next;
        });
      }, 350);
      return () => clearInterval(interval);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== activeLine) {
    t2 = CODE_LINES.map((row, i) => <div key={i} className="flex gap-1">{row.widths.map((w, j) => {
        const isActive = i === activeLine && row.color !== "none";
        const bgClass = isActive ? "bg-ds-brand-500" : COLOR_MAP[row.color];
        return <div key={j} className={`h-1 rounded-full ${bgClass}`} style={{
          width: w
        }} />;
      })}</div>);
    $[2] = activeLine;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex flex-col gap-1.5 p-5">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function ChatAvatar(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="border-ds-alpha-shadow-10 bg-ds-neutral-100 shadow-ds-elev-1 flex size-[42px] shrink-0 items-center justify-center overflow-clip rounded-full border">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
const PHASE_DELAYS = [600, 500, 500, 500, 12000, 400] as const;
const CHAT_PHASES = PHASE_DELAYS.length;
const FADE_OUT_PHASE = CHAT_PHASES - 1;
function CaddieChat() {
  const $ = _c(32);
  const [phase, setPhase] = useState(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      let current;
      current = 0;
      let timer;
      const step = () => {
        current = (current + 1) % CHAT_PHASES;
        setPhase(current);
        timer = setTimeout(step, PHASE_DELAYS[current]);
      };
      timer = setTimeout(step, PHASE_DELAYS[0]);
      return () => clearTimeout(timer);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== phase) {
    t2 = showAtPhase => ({
      opacity: phase >= showAtPhase && phase < FADE_OUT_PHASE ? 1 : 0,
      transition: "opacity 300ms ease"
    });
    $[2] = phase;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const msgStyle = t2;
  let t3;
  if ($[4] !== msgStyle) {
    t3 = msgStyle(1);
    $[4] = msgStyle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChatAvatar><img alt="Caddie AI assistant" src="/caddie/caddie-question.svg" className="size-[26px] object-contain" /></ChatAvatar>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bg-ds-alpha-black-10 h-1.5 w-[82px] rounded-full" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-col gap-1.5">{t5}<div className="border-ds-alpha-black-10 h-[11px] w-[155px] overflow-hidden rounded-full border bg-white"><div className="from-ds-alpha-black-10 rounded-ds-3 h-full w-3/4 bg-gradient-to-r to-transparent" /></div></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3) {
    t7 = <div className="flex items-start gap-4" style={t3}>{t4}{t6}</div>;
    $[9] = t3;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== msgStyle) {
    t8 = msgStyle(2);
    $[11] = msgStyle;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="bg-ds-alpha-black-10 h-1.5 w-[82px] rounded-full" />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex flex-col items-end gap-1.5">{t9}<div className="border-ds-alpha-black-10 h-[11px] w-[167px] overflow-hidden rounded-full border bg-white"><div className="from-ds-alpha-black-10 rounded-ds-3 h-full w-3/4 bg-gradient-to-r to-transparent" /></div></div>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ChatAvatar><svg className="size-5" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="7" r="3.5" fill="rgba(23,22,25,0.2)" /><path d="M3 18c0-3.866 3.134-7 7-7s7 3.134 7 7" fill="rgba(23,22,25,0.2)" /></svg></ChatAvatar>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t8) {
    t12 = <div className="flex items-start justify-end gap-4" style={t8}>{t10}{t11}</div>;
    $[16] = t8;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== msgStyle) {
    t13 = msgStyle(3);
    $[18] = msgStyle;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ChatAvatar><img alt="Caddie AI assistant" src="/caddie/caddie-question.svg" className="size-[26px] object-contain" /></ChatAvatar>;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="bg-ds-alpha-black-10 h-1.5 w-[82px] rounded-full" />;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const t16 = `border-ds-alpha-black-10 h-[65px] w-full overflow-hidden rounded-md border bg-white ${phase >= 3 && phase < FADE_OUT_PHASE ? "animate-caddie-pulse" : ""}`;
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="from-ds-alpha-black-10 rounded-ds-3 m-1 h-2/3 bg-gradient-to-r to-transparent" />;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t16) {
    t18 = <div className="flex flex-1 flex-col gap-1.5">{t15}<div className={t16}>{t17}</div></div>;
    $[23] = t16;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== t13 || $[26] !== t18) {
    t19 = <div className="flex items-start gap-4" style={t13}>{t14}{t18}</div>;
    $[25] = t13;
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t12 || $[29] !== t19 || $[30] !== t7) {
    t20 = <div className="rounded-ds-9 border-ds-alpha-black-10 mx-4 flex flex-col gap-6 border px-4 py-6">{t7}{t12}{t19}</div>;
    $[28] = t12;
    $[29] = t19;
    $[30] = t7;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  return t20;
}
const LOADING_TEXT = "Loading...";
const DOT_COUNT = 8;
const DOT_CIRCLES = Array.from({
  length: DOT_COUNT
}, (_, i) => {
  const angle = i / DOT_COUNT * Math.PI * 2 - Math.PI / 2;
  return {
    cx: 10 + Math.cos(angle) * 7,
    cy: 10 + Math.sin(angle) * 7
  };
});
function LoadingButton() {
  const $ = _c(11);
  const [charCount, setCharCount] = useState(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const interval = setInterval(() => {
        setCharCount(_temp2);
      }, 400);
      return () => clearInterval(interval);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="from-ds-brand-500 to-ds-brand-600 pointer-events-none absolute inset-0 rounded-xl bg-gradient-to-b" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="relative size-5 animate-spin [animation-duration:5s]" viewBox="0 0 20 20" fill="none">{DOT_CIRCLES.map(_temp3)}</svg>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== charCount) {
    t4 = LOADING_TEXT.slice(0, Math.min(charCount, LOADING_TEXT.length));
    $[4] = charCount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <span className="leading-label relative text-base font-medium text-white">{t4}</span>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="rounded-inherit shadow-ds-inner-light pointer-events-none absolute inset-0" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <div className="shadow-ds-brand absolute bottom-[40px] left-1/2 z-10 flex h-[44px] w-[175px] -translate-x-1/2 items-center gap-2 overflow-clip rounded-xl px-6 py-3">{t2}{t3}{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
function _temp3(dot, i) {
  return <circle key={i} cx={dot.cx} cy={dot.cy} r={1.3} fill="white" opacity={0.9} />;
}
function _temp2(prev) {
  return prev > LOADING_TEXT.length + 6 ? 0 : prev + 1;
}
function CreateCustomSolutionsCard() {
  const $ = _c(17);
  const {
    display,
    typedCount
  } = useTypingEffect(AI_PROMPTS);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="absolute inset-0 size-full opacity-50" aria-hidden="true">{GRID_H_LINES.map(_temp4)}{GRID_V_LINES.map(_temp5)}</svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="rounded-ds-2xl border-ds-neutral-200 bg-ds-neutral-100 absolute inset-0 overflow-clip border">{t0}<div className="absolute left-1/2 top-[104px] flex w-[88px] -translate-x-1/2 flex-col items-center gap-1"><div className="bg-ds-neutral-900 h-1 w-[46px] rounded-sm opacity-5" /><div className="bg-ds-neutral-900 h-1 w-full rounded-sm opacity-10" /><div className="bg-ds-neutral-900 h-1 w-[48px] rounded-sm opacity-[0.15]" /></div><div className="ai-radar-wave pointer-events-none absolute left-1/2 top-1/2 h-[1000px] w-[1000px] -translate-x-1/2 -translate-y-1/2" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="ai-glow absolute inset-0 rounded-full" />;
    t3 = <div className="ai-glow absolute inset-0 -scale-x-100 rounded-full" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [false, true].map(_temp6);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="bg-ds-neutral-700 ml-px inline-block h-3.5 w-0.5 translate-y-0.5 animate-pulse" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== display) {
    t6 = <span className="text-ds-text-secondary relative z-10 flex-1 truncate text-base">{display}{t5}</span>;
    $[6] = display;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="from-ds-brand-500 to-ds-brand-600 shadow-ds-brand relative z-10 flex size-9 shrink-0 items-center justify-center overflow-clip rounded-full bg-gradient-to-b"><svg className="size-5" viewBox="0 0 20 20" fill="none"><path d="M10 15V5M7 8l3-3 3 3" stroke="white" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg><span className="rounded-inherit shadow-ds-inner-light pointer-events-none absolute inset-0" /></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <div className="relative overflow-hidden rounded-full p-px">{t2}{t3}<div className="bg-ds-surface-primary shadow-ds-elev-3 relative flex items-center overflow-hidden rounded-full py-2.5 pl-6 pr-2.5">{t4}{t6}{t7}</div></div>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8 || $[12] !== typedCount) {
    t9 = <div className="ai-lights-wrapper relative h-[350px] overflow-hidden">{t1}<div className="absolute left-1/2 top-1/2 isolate w-[280px] -translate-x-1/2 -translate-y-1/2 sm:w-[391px]"><AiLights playSignal={typedCount}>{t8}</AiLights></div></div>;
    $[11] = t8;
    $[12] = typedCount;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <BentoCaption title="Create Custom Solutions" description="Build deterministic workflows end to end with AI - Plan, Execute and Test." />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}
function _temp6(mirrored) {
  return <div key={mirrored ? "m" : "n"} className={`pointer-events-none absolute inset-0 overflow-hidden rounded-full opacity-[0.12] ${mirrored ? "-scale-x-100" : ""}`} style={{
    maskImage: INNER_GLOW_MASK
  }}><div className="ai-glow absolute inset-[-50%] size-[200%]" /></div>;
}
function _temp5(i_0) {
  return <line key={`v-${i_0}`} x1={60 + i_0 * 60} y1="0" x2={60 + i_0 * 60} y2="100%" stroke="#e4e4e7" strokeWidth="1.5" />;
}
function _temp4(i) {
  return <line key={`h-${i}`} x1="0" y1={60 + i * 60} x2="100%" y2={60 + i * 60} stroke="#e4e4e7" strokeWidth="1.5" />;
}
export function BentoFeatures() {
  const $ = _c(62);
  const headlineRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true,
      amount: 0.4
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const headlineInView = useInView(headlineRef, t0);
  const gridRef = useRef(null);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      once: true,
      amount: 0.15
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const gridInView = useInView(gridRef, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      y: 20
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== headlineInView) {
    t3 = headlineInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 20
    };
    $[3] = headlineInView;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      duration: 0.6,
      ease: EASE_OUT_QUART
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="text-ds-alpha-shadow-30 font-mono text-base font-medium"><span>[</span><span className="text-ds-brand-600">01</span><span>/05] FEATURES</span></p>;
    t6 = <h2 className="text-ds-text-subtle leading-label max-w-[900px] text-4xl font-medium tracking-[-1.44px] md:text-7xl">Prompt It. Ship It. Trust It.</h2>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3) {
    t7 = <motion.div initial={t2} animate={t3} transition={t4} className="flex flex-col items-center gap-3 text-center">{t5}{t6}</motion.div>;
    $[8] = t3;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      opacity: 0,
      y: 12
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== headlineInView) {
    t9 = headlineInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 12
    };
    $[11] = headlineInView;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      duration: 0.5,
      delay: 0.15,
      ease: EASE_OUT_QUART
    };
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t9) {
    t11 = <motion.p initial={t8} animate={t9} transition={t10} className="text-ds-text-subtle leading-30 max-w-[620px] text-center text-xl">Go from idea to production workflow using pre-audited smart contracts and 300+ native nodes</motion.p>;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t7) {
    t12 = <div ref={headlineRef} className="px-6 py-20 pb-0"><div className="mx-auto max-w-[1240px]"><div className="mb-16 flex flex-col items-center gap-6">{t7}{t11}</div></div></div>;
    $[16] = t11;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <GridDivider variant={3} />;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="pointer-events-none absolute inset-0 z-[1] hidden justify-center md:flex" aria-hidden="true"><div className="w-full max-w-[1440px]"><div className="mx-[9px] h-full"><div className="bg-ds-neutral-200 mx-auto h-full w-px" /></div></div></div>;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      opacity: 0,
      y: 24
    };
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== gridInView) {
    t16 = gridInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 24
    };
    $[22] = gridInView;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      duration: 0.5,
      ease: EASE_OUT_QUART
    };
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="rounded-ds-xs absolute left-[29px] top-[29px] z-10 border border-transparent bg-white px-2 py-1.5 shadow-[inset_0px_0px_0px_1px_rgba(23,22,25,0.25),inset_0px_-2px_0px_0px_rgba(23,22,25,0.05)]"><span className="text-ds-text-secondary text-sm font-medium">300+ Native Nodes</span></div>;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="absolute bottom-[19px] left-[19px] opacity-60"><NodeCard title="Google Sheets: Get Values" subtitle="Action" subtitleColor="text-ds-success-accent" iconBg="bg-transparent" icon={<GridIcon />} /></div>;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="absolute right-[19px] top-[19px]"><NodeCard title="If-Then-Else" subtitle="Logic" subtitleColor="text-violet-600" iconBg="bg-violet-100" icon={<ForkIcon />} /></div>;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <ChartIcon />;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="absolute left-1/2 top-[87px] z-10 -translate-x-[calc(50%+121.5px)]"><NodeCard title="Token Price Trigger (CEXes)" subtitle="Trigger" subtitleColor="text-ds-focus-brand" iconBg="bg-[rgba(36,80,255,0.15)]" icon={t21} large={true} button={{
        label: "Send tokens to trigger"
      }} /></div>;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="absolute left-[calc(50%+104px)] top-[89px] hidden -translate-x-1/2 md:block"><img alt="Node connector line" src="/images/homepage/bento/v-connector.svg" className="h-[72px] w-[139px] rotate-180" /></div>;
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  let t24;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="absolute bottom-[167px] right-[129px] z-10 hidden md:flex"><div className="from-ds-neutral-100 to-ds-neutral-200 shadow-ds-white relative flex size-10 items-center justify-center rounded-full bg-gradient-to-b"><svg className="size-5" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="#3f3f46" strokeWidth={2} strokeLinecap="round" /></svg><span className="rounded-inherit shadow-ds-inner-light pointer-events-none absolute inset-0" /></div></div>;
    $[31] = t24;
  } else {
    t24 = $[31];
  }
  let t25;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="rounded-ds-sm border-ds-alpha-black-5 shadow-ds-neumorphic relative flex items-center gap-3 overflow-hidden border bg-white px-2 py-1.5"><svg className="relative size-4" viewBox="0 0 16 16" fill="none"><circle cx="4.33" cy="4" r="1.5" stroke="#7F56D9" strokeWidth={1.5} /><circle cx="11.67" cy="4" r="1.5" stroke="#7F56D9" strokeWidth={1.5} /><circle cx="4.33" cy="12" r="1.5" stroke="#7F56D9" strokeWidth={1.5} /><path d="M4.33 5.5V10.5" stroke="#7F56D9" strokeWidth={1.5} strokeLinecap="square" /><path d="M11.67 5.5V8H4.33V10.5" stroke="#7F56D9" strokeWidth={1.5} strokeLinecap="square" /></svg><span className="text-ds-text-tertiary relative text-sm font-medium">Add Logic Gate</span><span className="rounded-inherit shadow-ds-inner-bloom pointer-events-none absolute inset-0" /></div>;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="flex w-[200px] flex-col gap-1">{t25}<div className="rounded-ds-sm flex items-center gap-3 px-2 py-1.5"><svg className="size-4" viewBox="0 0 16 16" fill="none"><path d="M9.6 4.2H6.29L6.98 1L2.6 7.2H5.91L5.22 10.4L9.6 4.2Z" stroke="#3f3f46" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" /></svg><span className="text-ds-text-tertiary text-sm font-medium">Add Action</span></div></div>;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  let t28;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="rounded-ds-2xl border-ds-neutral-200 bg-ds-neutral-100 relative h-[240px] overflow-hidden border sm:h-[350px]"><div className="absolute left-1/2 top-0 h-[350px] w-[590px] origin-top -translate-x-1/2 scale-[0.56] sm:inset-0 sm:h-auto sm:w-auto sm:scale-100 sm:transform-none">{t18}{t19}{t20}{t22}{t23}{t24}<div className="absolute right-[41px] top-[201px] z-20 hidden xl:block"><div className="rounded-ds-18 border-ds-neutral-200 relative flex flex-col gap-1.5 border bg-white p-2">{t26}<div className="absolute left-[125.5px] top-[27.5px] size-[30px]"><svg className="size-full" viewBox="0 0 30 30" fill="none"><path d="M8 5l2 18 4-6 7-2L8 5z" fill="#171619" stroke="white" strokeWidth={1} /></svg></div></div></div></div></div>;
    t28 = <BentoCaption title="Visual Block Builder" description="Build, modify and track workflows with visual builder." />;
    $[34] = t27;
    $[35] = t28;
  } else {
    t27 = $[34];
    t28 = $[35];
  }
  let t29;
  if ($[36] !== t16) {
    t29 = <motion.div initial={t15} animate={t16} transition={t17}>{t27}{t28}</motion.div>;
    $[36] = t16;
    $[37] = t29;
  } else {
    t29 = $[37];
  }
  let t30;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      opacity: 0,
      y: 24
    };
    $[38] = t30;
  } else {
    t30 = $[38];
  }
  let t31;
  if ($[39] !== gridInView) {
    t31 = gridInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 24
    };
    $[39] = gridInView;
    $[40] = t31;
  } else {
    t31 = $[40];
  }
  let t32;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      duration: 0.5,
      delay: 0.12,
      ease: EASE_OUT_QUART
    };
    $[41] = t32;
  } else {
    t32 = $[41];
  }
  let t33;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="border-ds-neutral-200 absolute inset-x-5 bottom-0 top-6 border"><div className="border-ds-neutral-200 flex items-center gap-2.5 border-b px-[15px] py-[13px]"><div className="bg-ds-alpha-black-5 ring-ds-neutral-200 size-3 rounded-full ring-1" /><div className="bg-ds-alpha-black-5 ring-ds-neutral-200 size-3 rounded-full ring-1" /><div className="bg-ds-alpha-black-5 ring-ds-neutral-200 size-3 rounded-full ring-1" /></div></div>;
    $[42] = t33;
  } else {
    t33 = $[42];
  }
  let t34;
  let t35;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <div className="rounded-ds-2xl border-ds-neutral-200 bg-ds-neutral-100 relative h-[350px] overflow-hidden border">{t33}<div className="absolute left-1/2 top-[60px] w-[90%] max-w-[443px] -translate-x-1/2"><div className="rounded-ds-14 border-ds-neutral-200 bg-ds-surface-primary shadow-ds-cream-card border"><div className="flex gap-[7px] px-5 py-4"><div className="bg-ds-window-red size-[11px] rounded-full" /><div className="bg-ds-window-amber size-[11px] rounded-full" /><div className="bg-ds-window-green size-[11px] rounded-full" /></div><CaddieChat /></div></div></div>;
    t35 = <BentoCaption title="Your AI Copilot, Caddie" description="Prompt and edit workflows with sandboxed AI." />;
    $[43] = t34;
    $[44] = t35;
  } else {
    t34 = $[43];
    t35 = $[44];
  }
  let t36;
  if ($[45] !== t31) {
    t36 = <motion.div initial={t30} animate={t31} transition={t32}>{t34}{t35}</motion.div>;
    $[45] = t31;
    $[46] = t36;
  } else {
    t36 = $[46];
  }
  let t37;
  if ($[47] !== t29 || $[48] !== t36) {
    t37 = <div ref={gridRef} className="mx-auto max-w-[1440px] px-6 py-6"><div className="grid grid-cols-1 gap-6 md:grid-cols-2">{t29}{t36}</div></div>;
    $[47] = t29;
    $[48] = t36;
    $[49] = t37;
  } else {
    t37 = $[49];
  }
  let t38;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <GridDivider variant={3} />;
    $[50] = t38;
  } else {
    t38 = $[50];
  }
  let t39;
  let t40;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = ["calc(50%-55px)", "calc(50%+114px)"].map(_temp7);
    t40 = ["calc(50%-232px)", "calc(50%+232px)"].map(_temp8);
    $[51] = t39;
    $[52] = t40;
  } else {
    t39 = $[51];
    t40 = $[52];
  }
  let t41;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <div className="rounded-ds-2xl border-ds-neutral-200 bg-ds-surface-primary shadow-ds-soft absolute left-1/2 top-[56px] w-[297px] -translate-x-1/2 border"><div className="border-ds-neutral-200 h-[37px] border-b" /><CodeLines /></div>;
    $[53] = t41;
  } else {
    t41 = $[53];
  }
  let t42;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <div className="rounded-ds-2xl border-ds-neutral-200 bg-ds-neutral-100 absolute left-[calc(50%-298px)] top-[70px] h-[143px] w-[248px] -translate-x-1/2 border"><div className="border-ds-neutral-200 h-[37px] border-b" /></div>;
    $[54] = t42;
  } else {
    t42 = $[54];
  }
  let t43;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <div className="mx-auto max-w-[1440px] px-6 py-6"><div className="grid grid-cols-1 gap-6 md:grid-cols-2"><div><div className="rounded-ds-4xl bg-ds-neutral-100 relative h-[350px] overflow-clip">{t39}{t40}{t41}{t42}<div className="rounded-ds-2xl border-ds-neutral-200 bg-ds-neutral-100 absolute left-[calc(50%+300px)] top-[70px] h-[143px] w-[248px] -translate-x-1/2 border"><div className="border-ds-neutral-200 h-[37px] border-b" /></div><LoadingButton /></div><BentoCaption title="Expert Audited Code" description="B3OS produces code using pre-audited contracts, templates, and primitives built by the S-tier engineers." /></div><CreateCustomSolutionsCard /></div></div>;
    $[55] = t43;
  } else {
    t43 = $[55];
  }
  let t44;
  if ($[56] !== t37) {
    t44 = <GridBorderedSection>{t14}{t37}{t38}{t43}</GridBorderedSection>;
    $[56] = t37;
    $[57] = t44;
  } else {
    t44 = $[57];
  }
  let t45;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <GridDivider variant={3} />;
    $[58] = t45;
  } else {
    t45 = $[58];
  }
  let t46;
  if ($[59] !== t12 || $[60] !== t44) {
    t46 = <section id="features">{t12}{t13}{t44}{t45}</section>;
    $[59] = t12;
    $[60] = t44;
    $[61] = t46;
  } else {
    t46 = $[61];
  }
  return t46;
}
function _temp8(left) {
  return <svg key={left} className="absolute top-0 h-full w-px" style={{
    left
  }} preserveAspectRatio="none" viewBox="0 0 1 350"><line x1="0.5" y1="0" x2="0.5" y2="350" stroke="#e4e4e7" strokeWidth="1" strokeDasharray="4 4" /></svg>;
}
function _temp7(top) {
  return <div key={top} className="text-ds-text-faint text-5xs pointer-events-none absolute left-1/2 flex h-[440px] w-[486px] -translate-x-1/2 -translate-y-1/2 flex-col justify-center overflow-hidden text-center font-mono leading-[17px] tracking-[-0.16px] opacity-50" aria-hidden="true" style={{
    top,
    maskImage: "radial-gradient(ellipse 130px 130px at center, black, transparent)",
    WebkitMaskImage: "radial-gradient(ellipse 130px 130px at center, black, transparent)"
  }}><p>nX5GkMbQWr9$8394ZUNJlEOpT</p><p>HsKFXJQsVgyceM5BFk8hzPltbxY8THKmR/</p><p>fNP2OP1zAmOPEcuUr29l0Lnv33e6S2W2ItDOw92Y</p><p>/YGHGFIKh99xXA abcdefghijCDE9C 3UPNMGYm07irv</p><p>NyiJFvs9A£ZTTUXGbLgFo0iAwT3M5XDOJnm420ITRN52</p><p>152VKJpmMfZh9yqJ3Uw9lM6hiIfSPjAPr70QMupsktjB0</p><p>j5200Z4N8WN3osJ5ACclor27 AXcvIeW7NoJEezTRnVEDT</p><p>2B41t7hyUxNBVz3TI 2MPQOYLGJlmgTbhwth.</p><p>qFsFmLRsFl3U74Xb! GH4kvLCyQSOBzaCVhi</p><p>DpKhLMrXsGnFmB7C29vZHsKFXJQsVgyceM5BFk8h</p><p>GXkarIRSkN68cTTzQirDfg3FphE12Jn9aKc</p><p>MAvE4vLZVbsoqPRqQXYAu1vRrYK9Fw2UCXpBM</p><p>udGxXsZJLLft7Pxx6FD4fMPIlYeVQV0</p></div>;
}